export default "__VITE_ASSET__DJm_xkAz__"